import {useCallback, useState} from "react"
type AlertState = {
	open: boolean
	type: string | null
	message?: string
}

function useAlert() {
	const [state, setState] = useState<AlertState>({
		open: false,
		type: null,
		message: undefined,
	})

	const open = useCallback((type: string, message?: string) => {
		setState({open: true, type, message})
	}, [])

	const close = useCallback(() => {
		setState((prev: Omit<AlertState, "open">) => ({...prev, open: false}))
	}, [])

	return {state, open, close}
}
export default useAlert
